import React from 'react';
import WorkZoneMobileNavigation from './NavigationMobile';
import HeaderNavBar from '../../../components/HeaderNavBar';

const WorkZoneHeader = () => {
  return <HeaderNavBar mobileNavigation={WorkZoneMobileNavigation} />;
};

export default WorkZoneHeader;
